import api from '@mint-lib/api';

import {
  NormalizedMainCurrencyItem,
  normalizeMainCurrencyAxiosResponse,
  WithCurrenciesApiResponse,
} from '../../index.js';
import { MAIN_CURRENCIES } from '../endpoints.js';

export const fetchMainCurrencies = async (): Promise<
  WithCurrenciesApiResponse<NormalizedMainCurrencyItem[]>
> => {
  return api.get(MAIN_CURRENCIES).then((data) => {
    return normalizeMainCurrencyAxiosResponse(data);
  });
};
